export const ASSORTMENTS = {
    TITLE: "title",
    CREATE_ASSORTMENT: "create-new-assortment",
    CREATE_INTERNAL: "create-internal-assortment",
    CREATE_EXTERNAL: "create-external-assortment",
    START_ASSORTMENT_MODAL: "start-assortment-modal",
    CREATE_TARGET_MODAL: "create-targets-modal",
    MANAGE_TARGETS_MODAL: "manage-targets-modal",

    ASSORTMENT_LIST_ACTIONS_BTN: "assortment-list-actions-btn",

    ASSORTMENT_HEADER: "assortment-header",
    ASSORTMENTS_PAGE_LINK: "assortments-page-link",

    ASSORTMENT_ROW: "assortment-row",
    ASSORTMENT_PERMISSION: "assortment-permission",

    BRAND_LIST_HEADER_TEXT: "brand-list-header-text",
    BRAND_SEARCH_INPUT: "brand-search-input",
    ASSORTMENT_SEARCH_INPUT: "assortment-search-input",
    GLOBAL_SEARCH_INPUT: "global-search-input",
    GLOBAL_SEARCH_ENTER: "global-search-enter",

    ASSORTMENT_TAB: "assortment-tab",
    SHOP_TAB: "shop-tab",
    LINESHEETS_TAB: "linesheets-tab",
    CART_BTN: "cart-btn",
    TILE_VIEW_BTN: "tile-view-btn",
    GRID_VIEW_BTN: "grid-btn",

    GRID: {
        GRID_WRAPPER: "assortment__grid-wrapper",
        TEXT_CELL_EDITOR: "text-cell-editor",
        NUMBER_CELL_EDITOR: "number-cell-editor",
        DATE_CELL_EDITOR: "date-cell-editor",
        DATE_PICKER_CELL_EDITOR: "date-picker-cell-editor",
        SINGLE_CHOICE_CELL_EDITOR: "single-choice-cell-editor",
        DATE_PICKER_INPUT_CELL_EDITOR: "date-picker-input-cell-editor",
        DATE_PICKER_INPUT_CELL_CLEAR_BUTTON: "date-picker-input-cell-clear-button",
    },

    TILE: {
        DEFAULT_TILE_VIEW_BTN: "default-tile-view-btn",
        TEMPLATE_TILE_VIEW_BTN: "template-tile-view-btn",
        CONFIGURE_TILE_VIEW_BTN: "configure-tile-view-btn",
        EXPAND_TILE_VIEW_BTN: "expand-tile-view-btn",
        SETTINGS: {
            MODAL: {
                BODY: "tile-settings-modal-body",
                PREVIEW: {
                    FIRST_LINE: "tile-settings-modal-preview-first-line",
                    SECOND_LINE: "tile-settings-modal-preview-second-line",
                    THIRD_LINE: "tile-settings-modal-preview-third-line",
                    FOURTH_LINE: "tile-settings-modal-preview-fourth-line",
                    FIFTH_LINE: "tile-settings-modal-preview-fifth-line",
                    SIXTH_LINE: "tile-settings-modal-preview-sixth-line",
                    SEVENTH_LINE: "tile-settings-modal-preview-seventh-line",
                    EIGHTH_LINE: "tile-settings-modal-preview-eighth-line",
                    COLOR_SWATCH: "tile-settings-modal-preview-color-swatch",
                    TOTAL_COST: "tile-settings-modal-preview-total-cost",
                    TOTAL_RETAIL: "tile-settings-modal-preview-total-retail",
                    UNITS_DOORS: "tile-settings-modal-preview-units-doors",
                },
                FORM: {
                    FIRST_LINE: "tile-settings-modal-form-first-line",
                    SECOND_LINE: "tile-settings-modal-form-second-line",
                    THIRD_LINE: "tile-settings-modal-form-third-line",
                    FOURTH_LINE: "tile-settings-modal-form-fourth-line",
                    FIFTH_LINE: "tile-settings-modal-form-fifth-line",
                    SIXTH_LINE: "tile-settings-modal-form-sixth-line",
                    SEVENTH_LINE: "tile-settings-modal-form-seventh-line",
                    EIGHTH_LINE: "tile-settings-modal-form-eighth-line",
                    COLOR_SWATCH: "tile-settings-modal-form-color-swatch",
                    TOTAL_COST: "tile-settings-modal-form-total-cost",
                    TOTAL_RETAIL: "tile-settings-modal-form-total-retail",
                    UNITS: "tile-settings-modal-form-total-units",
                    DOORS: "tile-settings-modal-form-total-doors",
                    EACHES_ON_HOVER: "tile-settings-modal-form-eaches-on-hover",
                },
            },
            PRODUCT: {
                COLOR_SWATCH: "tile-settings-product-color-swatch",
                TOTAL_COST: "tile-settings-product-total-cost",
                TOTAL_RETAIL: "tile-settings-product-total-retail",
                UNITS_DOORS: "tile-settings-product-total-units-doors",
            },
        },
    },

    SHOP: {
        DEFAULT_TILE_VIEW_BTN: "default-tile-view-btn",
        TEMPLATE_TILE_VIEW_BTN: "template-tile-view-btn",
        CONFIGURE_TILE_VIEW_BTN: "configure-tile-view-btn",
        EXPAND_TILE_VIEW_BTN: "expand-tile-view-btn",
        SETTINGS: {
            MODAL: {
                BODY: "shop-settings-modal-body",
                PREVIEW: {
                    FIRST_LINE: "shop-settings-modal-preview-first-line",
                    SECOND_LINE: "shop-settings-modal-preview-second-line",
                    THIRD_LINE: "shop-settings-modal-preview-third-line",
                    FOURTH_LINE: "shop-settings-modal-preview-fourth-line",
                    FIFTH_LINE: "shop-settings-modal-preview-fifth-line",
                    SIXTH_LINE: "shop-settings-modal-preview-sixth-line",
                    SEVENTH_LINE: "shop-settings-modal-preview-seventh-line",
                    EIGHTH_LINE: "shop-settings-modal-preview-eighth-line",
                    SHOW_COST: "shop-settings-modal-preview-total-cost",
                    SHOW_RETAIL: "shop-settings-modal-preview-total-retail",
                },
                FORM: {
                    SHOW_COST: "shop-settings-modal-form-total-cost",
                    SHOW_RETAIL: "shop-settings-modal-form-total-retail",
                },
            },
            PRODUCT: {
                COST: "shop-settings-product-total-cost",
                RETAIL: "shop-settings-product-total-retail",
            },
        },
    },

    ALL_BRANDS_TOGGLE: "all-brands-toggle",
    BRAND_TOGGLE: "brand-toggle",
    BRAND_PICKER: "brand-picker",

    DIALOG: {
        CLONE: "clone",
        DELETE: "delete",
        CANCEL: "cancel",
        SAVE: "save",
        COPY: "copy",
    },

    ASSORMENT_SETTINGS: {
        ALERT_MESSAGE: "assortment-settings-alert-message",
        DEPARTMENT_ID: "assortment-settings-department-id",
        LOOK_UP_FIELD: "assortment-settings-look-up-field",
        LOOK_UP_DERIVATIVE_FIELD: "assortment-settings-look-up-derivative-field",
        NAME: "assortment-settings-name",
        MARKET_DATE: "assortment-settings-market-date",
        DUE_DATE: "assortment-settings-due-date",
        BRAND_CONTACT: "assortment-settings-brand-contact",
        MARKET_STATUS: "assortment-settings-market-status",
    },

    ASSORTMENT_VIEW_ACTION_BTN: "assortment-view-action-btn",
    ADD_SMU_BTN: "add-smu-btn",
    SYNC_PRODUCT_DATA: {
        MAIN_BUTTON: "sync-product-data__main-button",
        STOP_SYNC_BUTTON: "sync-product-data__stop-sync-button",
        ALL_PRODUCTS_BUTTON: "sync-product-data__all-products-button",
        FILTERED_PRODUCTS_BUTTON: "sync-product-data__filtered-products-button",
    },
    FIND_SIZE_RANGES_BTN: "find-size-ranges-btn",
    APPLY_SIZE_CURVES_BTN: "apply-size-curves",
    TITLE_SIZE_SETTINGS_MODAL: "title-size-settings-modal",
    SAVE_AS_BTN: "save-as-btn",
    SYNC_INVENTORY_UNITS_BTN: "sync-inventory-units-btn",
    NOTIFICATIONS_BTN: "notifications-btn",
    EXPORT_BTN: "export-btn",
    EXPORT_MERCHANT_BTN: "export-merchant-btn",
    EXPORT_MERCHANT_BTN_DIALOG: "export-merchant-btn-dialog",
    EXPORT_MERCHANT_CLOSE_BTN_DIALOG: "export-merchant-close-btn-dialog",
    EXPORT_MERCHANT_REQUIRED_ALERT: "export-merchant-required-alert",
    EXPORT_MERCHANT_DESIRED_ALERT: "export-merchant-desired-alert",
    JWN_BTN: "jwn-btn",
    DELETE_ASSORTMENT_BTN: "delete",
    OPERATION_HISTORY_BTN: "operation-history-btn",
    MANAGE_UPC_BTN: "manage-upc-btn",
    MANAGE_DISTRIBUTION_DIALOG_BTN: "manage-distribution-dialog-btn",
    EXPORT_UPC_BTN: "export-upc-btn",
    IMPORT_UPC_BTN: "import-upc-btn",
    CONFIRM_DELETE_INPUT: "confirm-delete-input",
    LEAVE_ASSORTMENT_BTN: "leave-assortment-btn",
    COPY_ASSORTMENT_BTN: "copy-assortment-btn",
    ASSORTMENT_SETTINGS_BTN: "assortment-settings-btn",
    CHOOSE_ASSORTMENT_DESTINATION_BTN: "choose-assortment-destination-btn",
    CHOOSE_ASSORTMENT_DESTINATION_TEXT: "choose-assortment-destination-text",
    COPY_ASSORTMENT_INPUT: "copy-assortment-input",
    COPY_ASSORTMENT_MERCHANT_DROPDOWN: "copy-assortment-merchant-dropdown",
    COPY_ASSORTMENT_BRAND_DROPDOWN: "copy-assortment-brand-dropdown",
    COPY_ASSORTMENT_SELECT_TYPE: "copy-assortment-select-type",
    COPY_ASSORTMENT_SHARE_WITH_SAME_PEOPLE_CBX: "copy-assortment-share-with-same-people-cbx",
    COPY_ASSORTMENT_SHARE_WITH_DEFAULT_ROW_CBX: "copy-assortment-include-default-row",
    COPY_ASSORTMENT_INCLUDE_DOOR_LABELS: "copy-assortment-include-door-labels",
    COPY_ASSORTMENT_INCLUDE_NOTE_CBX: "copy-assortment-include-note-cbx",
    COPY_ASSORTMENT_INCLUDE_PO_DETAILS: "copy-assortment-include-po-details",
    COPY_ASSORTMENT_INCLUDE_ALLOCATION: "copy-assortment-include-allocation",
    COPY_ASSORTMENT_INCLUDE_PLAN: "copy-assortment-include-plan",
    COPY_ASSORTMENT_INCLUDE_TARGET: "copy-assotment-include-target",
    COPY_ASSORTMENT_ERROR: "copy-assortment-error",
    SIZE_SETTINGS: "size-settings-btn",
    MANAGE_SIZES_BTN: "manage-sizes-btn",

    EXPORT_CURRENT_VIEW: "export-current-view",
    EXPORT_WITH_IMAGES: "export-with-images",

    BULK_ACTIONS_CONTAINER: "bulk-actions-container",
    BULK_ACTION_BTN: "bulk-action-btn",
    BULK_DELETE_BTN: "bulk-delete-btn",
    BULK_COPY_BTN: "bulk-copy-btn",
    BULK_ALLOCATE_SIZE_CURVE_BTN: "bulk-allocate-size-curve-btn",
    BULK_SYNC_INVENTORY_UNITS_BTN: "bulk-sync-inventory-units-btn",

    CHAT_BTN: "chat-btn",
    CHAT_PANEL: "chat-panel",
    CHAT_INPUT: "chat-input",
    CHAT_SEND: "chat-send",
    CHAT_BEGINNING: "beginning-of-chat",
    CHAT_CONTAINER: "chat-container",
    CHAT_READ: "chat-read",
    CHAT_UNREAD: "chat-unread",
    CHAT_MESSAGE: "chat-message",

    HISTORY_BTN: "history-btn",
    HISTORY_EXIT: "history-exit",
    HISTORY_CONTAINER: "history-container",
    HISTORY_HEADER: "history-header",
    HISTORY_VERSION: "version-history",
    HISTORY_PANEL: "history-panel",
    HISTORY_POI_ENTRY: "history-poi-entry",
    HISTORY_CURRENT_VERSION: "history-current-version",

    SHARE_BTN: "share-btn",
    SHARE_CONTACT_SEARCH: "contact-search",
    SHARE_SEARCH_DROPDOWN: "search-dropdown",
    SHARE_SEARCH_RESULT: "search-result",
    SHARE_NO_RESULTS: "no-results",
    SHARE_PERMISSION_SELECTOR: "permission-selector",
    SHARE_ADD_RECIPIENT_BTN: "add-recipient-btn",
    SHARE_CURRENT_PERMISSION: "share-current-permission",
    SHARE_RECIPIENTS_CONTAINER: "recipients-container",
    SHARE_RECIPIENT_ROW: "recipient-row",
    REMOVE_RECIPIENT: "remove-recipient",
    CONFIRM_REMOVE_RECIPIENT: "confirm-remove-recipient",

    SAVED_VIEWS_LIST: "saved-views-list",
    ROLLUP_DEFAULT_VIEW_MASTER: "rollup-default-view-master",
    ROLLUP_ACCORDION_MENU: "rollup-accordion-menu",
    VIEWS_NAME_INPUT: "view-name-input",
    VIEWS_CANCEL: "cancel-view",
    VIEWS_SAVE: "save-view",
    VIEWS_PROMOTE: "promote-view",
    VIEWS_SAVE_CURRENT: "save-current-view",
    VIEWS_ACTION_MENU: "view-action-menu",
    SAVED_VIEWS_UPDATE: "saved-view-update",
    MERCHANT_SAVED_VIEWS_UPDATE: "merchant-saved-view-update",
    MERCHANT_SAVED_VIEWS_DELETE: "merchant-saved-view-delete",
    SAVED_VIEWS_PROMOTE: "saved-view-promote",
    SAVED_VIEWS_SAVE_AS: "saved-view-save-as",
    SAVED_VIEWS_DELETE: "saved-view-delete",
    SAVED_VIEWS_RESET: "saved-view-reset",
    SAVED_VIEW_CHIP: "saved-view-chip",

    // SHARED MODAL CONST
    DETAILS_PRODUCT_NAME: "details-product-name",
    DETAILS_STYLE_NUMBER: "details-style-number",
    DETAILS_PRODUCT_COLOR: "details-product-color",
    DETAILS_PRODUCT_FORM: "details-product-form",
    DETAILS_CLOSE_BTN: "details-close-btn",

    PDP: {
        PRODUCT_DETAILS_CONTAINER: "pdp-container",
        HERO_IMAGE_ZOOM: "hero-image-zoom",
        NO_IMAGE: "no-image-icon",
        PRIMARY_IMAGE: "primary-image",

        ADD_TO_ASSORTMENT: "add-to-assortment",
        EDIT_IN_ASSORTMENT: "edit-in-assortment",

        TRANSFORM_COMPONENT: "transform-component",
        ZOOM_HEADER: "zoom-header",
        ZOOM_IN_BTN: "zoom-in-btn",
        ZOOM_OUT_BTN: "zoom-out-btn",
        ZOOM_CLOSE_BTN: "zoom-close-btn",
    },
    CDP: {
        CART_DETAILS_CONTAINER: "cdp-container",
        ADDITIONAL_IMAGE: "image",
        PRIMARY_IMAGE_DETAILS: "primary-image-details",
        SET_AS_PRIMARY_IMAGE: "set-as-primary-image",
        DELETE_IMAGE: "delete-image",
        ZOOM_IMAGE: "zoom-image",
        IMAGE_UPLOAD: "image-upload",
        OVERVIEW_TAB: "cdp_overview_tab_button",
        SIZING_TAB: "cdp_sizing_tab_button",
        DETAILS_TAB: "cdp_details_tab_button",
        SIZE_COLUMN: "cdp_size_column",

        CDP_ACTIONS_KABOB: "cdp-actions-kabob",
        FIND_SIZE_RANGE_BTN: "find-size-range",
        STOP_SIZE_RANGE_BTN: "stop-find-size-range",
        APPLY_SIZE_CURVES_BTN: "apply-size-curves",
        STOP_APPLY_CURVES_BTN: "stop-apply-size-curves",
        COPY_ALLOCATION_BTN: "copy-allocation",
        PASTE_ALLOCATION_BTN: "paste-allocation",
        COPY_BTN: "copy-btn",
        TRASH_BTN: "trash-btn",

        LINK_PRODUCT_BTN: "link-product-btn",
        LINK_PRODUCT_FORM: "link-product-form",
        LINK_PRODUCT_INPUT: "link-product-input",
        CONFIRM_LINK_BTN: "confirm-link-btn",
        REMOVE_LINK: "remove-link",
        SIZE_HEADER_CONTAINER: "size-header-container",
        VENDOR_SIZES_HEADER: "vendor-sizes-header",
        SELECTED_SIZES_HEADER: "selected-sizes-header",
        SIZE_LOOKUP_HEADER: "size-lookup-header",
        SIZE_CURVE_HEADER: "size-curve-header",
        SIZING_STATUS_HEADER: "sizing-status-header",
        VENDOR_SIZES_VALUE: "vendor-sizes-value",
        SELECTED_SIZES_VALUE: "selected-sizes-value",
        SIZE_LOOKUP_VALUE: "size-lookup-value",
        SIZE_CURVE_VALUE: "size-curve-value",
        SIZING_STATUS_VALUE: "sizing-status-value",
        SELECTED_PACKS_HEADER: "selected-packs-header",
    },

    SHOP_CART_BTN: "shop-cart-btn",
    SHOP_PRODUCT_CARD: "shop-product-card",
    SHOP_CARD_PRODUCT_NAME: "shop-card-product-name",
    SHOP_CARD_DETAILS_CONTAINER: "shop-card-details-container",
    SHOP_ACTION_MENU: "shop-action-menu",
    SHOP_ADD_ALL_PRODUCTS: "shop-add-all-products",
    SHOP_UNSYNCED_BTN: "shop-unsynced-btn",
    SHOP_VIEW_DEFAULT_SETTINGS_BTN: "shop-view-default-settings-btn",
    SHOP_VIEW_CONFIGURE_BTN: "shop-view-configure-btn",

    CONTINUE_SHOPPING_BTN: "continue-shopping-btn",
    BREADCRUMB_ALL_BRANDS: "breadcrumb-all-brands",
    BREADCRUMB_SHOWING_RESULTS_FOR: "breadcrumb-showing-results-for",

    CLEAR_FILTERS: "clear-filters",
    FILTER_ALL: "filter-all",
    FILTER_SMU_ONLY: "filter-SMUOnly",
    FILTER_EXCLUDE_SMU: "filter-excludeSMU",

    FILTERS: {
        AVAILABILITY: {
            IMMEDIATE: "subfilter-immediate",
        },
        DELIVERIES: {
            AVAILABLE_FROM: "chevron-availablefrom",
            EARLIEST_DATE: "__min_key-minkey",
            LATEST_DATE: "__max_key-maxkey",
        },
        STATUS: {
            FILTER_STATUS: "filter-status",
            ACTIVE: "radio-active",
            INACTIVE: "radio-inactive",
            ALL: "radio-all",
        },
    },

    ALL_PRODUCTS_LINESHEET: "linesheet-all-products-linesheet",

    // PULLED FEATURES
    ALLOCATION_GRID: "allocation-grid",
    PLAN_BTN: "plan-btn",
    PO_BTN: "po_btn",
    UNDO_BTN: "undo-btn",
    REDO_BTN: "redo-btn",

    PENDING_COLLECTION_MODAL_CLOSE: "pending-collection-modal-close-btn",
    PENDING_COLLECTION_RETRY: "pending-collection-retry-btn",
    PENDING_COLLECTION_EXPORT: "pending-collection-export-btn",
    PENDING_COLLECTION_PURGE: "pending-collection-purge-btn",
    PENDING_COLLECTION_PURGE_CANCEL: "pending-collection-cancel-btn",

    NESTED_VIEW_BTN: "nested-view-btn",
    DOOR_MENU_BTN: "door-menu-btn",
    TILE_MENU_BTN: "tile-menu-btn",
    TILE_BTN: "tile-btn",
    DOORS_BTN: "doors-btn",
    SHOW_DOOR_PLAN_BTN: "show-door-plan",
    SHOW_VIEW_DOOR_LABELS_BTN: "show-view-door-labels-btn",
    GROUP_DOORS_BTN: "group-doors-btn",

    ALLOCATION_DIMENSIONS: {
        MODAL_TITLE: "allocation-dimensions__modal-title",
        TABS: {
            IMPORT_DOOR_GROUPINGS: "allocation-dimensions__tabs_import-door-groupings",
            EDIT_DOOR_GROUPINGS: "allocation-dimensions__tabs_edit-door-groupings",
        },
        MANAGE_DOOR_BTN: "allocation-dimensions__manage-door-btn",
        EXPORT_BTN: "allocation-dimensions__export-btn",
        GRID_WRAPPER: "allocation-dimensions__grid-wrapper",
        IMPORT_DOOR_GROUPINGS: {
            UPLOADER: {
                TITLE: "import-door-groupings__uploader__title",
                DROPZONE_COMPONENT: "import-door-groupings__uploader__dropzone-component",
                ALERT: {
                    INFORMATION: "import-door-groupings__uploader__alert__error",
                    ERROR: "import-door-groupings__uploader__alert__error",
                },
                REMINDER: {
                    TITLE: "import-door-groupings__uploader__reminder__title",
                    LIST: "import-door-groupings__uploader__reminder__list",
                },
            },
            SUMMARIZE_COLUMN: {
                CREATED: {
                    TITLE: "import-door-groupings__summarize-column__created__title",
                    LIST: "import-door-groupings__summarize-column__created__list",
                    ITEM: "import-door-groupings__summarize-column__created__item",
                },
                UPDATED: {
                    TITLE: "import-door-groupings__summarize-column__updated__title",
                    LIST: "import-door-groupings__summarize-column__updated__list",
                    ITEM: "import-door-groupings__summarize-column__updated__item",
                },
                DOORS: {
                    TITLE: "import-door-groupings__summarize-column__doors__title",
                    LIST: "import-door-groupings__summarize-column__doors__list",
                    ITEM: "import-door-groupings__summarize-column__doors__item",
                },
                DOOR_WITH_UNITS: {
                    TITLE: "import-door-groupings__summarize-column__door-with-units__title",
                    LIST: "import-door-groupings__summarize-column__door-with-units__list",
                    ITEM: "import-door-groupings__summarize-column__door-with-units__item",
                },
            },
            ERRORS: {
                MESSAGE: "import-door-groupings__errors__message",
            },
            BUTTON_NEXT: "import-door-groupings__button-next",
        },
    },

    DELIVERY_PURCHASE_ORDERS: {
        MANAGE_PO_BTN: "delivery-purchase-orders__manage-po-btn",
        GRID_WRAPPER: "delivery-purchase-orders__grid-wrapper",
    },

    REVIEW_TAB: {
        TAB_BUTTON: "review-tab",
        DOORS_DROPDOWN: "doors-select",
        DOORS_DROPDOWN_ELEMENT: "doors-select-element",
        SEARCH_PRODUCT: "review-tab-search-product",
        PRODUCTS_LIST_ITEM: "review-tab-products-list-item",
        VERSION_STATUS_DROPDOWN_ELEMENT: "version-status-dropdown-element",
        BALANCE_CLOSE_BTN_DIALOG: "balance-close-button-dialog",
        BALANCE_ALL_CONFIRM_BTN_DIALOG: "balance-all-confirm-button-dialog",
        RESET_VIEW: "reset-view",
        CHOOSE_PRODUCT_TITLE: "choose-product-title",
        CHOOSE_DOOR_TITLE: "choose-door-title",
    },

    POI_TAGS: {
        VERSION_STATUS_MENU_ITEM: "version-status-menu-item",
        VERSION_STATUS_MENU: "version-status-menu",
    },

    ROW_IMAGE_CELL: "row-image-cell",
    MISSING_ASSORTMENT_ALERT_CONTENT: "missing_assortment_alert_content",
    TOO_MANY_MUTATIONS_ALERT_CONTENT: "too_many_mutations_alert_content",
    CLOSE_CAPTURE_BTN: "close-capture-btn",
    CAPTURE_BULKS_BTN: "capture-bulks-btn",

    FOOTER: {
        TOTAL_PRODUCTS: "total-products",
        TOTAL_ROWS: "total-rows",
        TOTAL_UNITS: "total-units",
        TOTAL_COST: "total-cost",
        TOTAL_RETAIL: "total-retail",
        TOTAL_MARKUP: "total-markup",
        PENDING_CHANGES: "pending-changes-badge",
        MANAGE_TARGETS: {
            EMPTY_VIEW: "manage-targets-empty-view",
            BUDGET_GROUP_LIST_CONTAINER: "budget-group-list-container",
            BUDGET_GROUP_EDIT_ITEM: "budget-group-edit-item",
            BUDGET_GROUP_DELETE_ITEM: "budget-group-delete-item",
            TARGET_GROUP: {
                EXPAND_BUTTON: "target-group-expand-button",
                GROUP_CONTAINER: "target-group-container",
                GROUP_SUBLIST_CONTAINER: "target-group-sublist-container",
                SUB_LIST: {
                    CONTAINER: "target-group-sublist-container",
                },
                GROUP_CHECK: "target-grou-check",
            },
            ADD_TARGET_VALUES_CONTAINER: {
                GRID: "add-target-values-container-grid",
            },
            DONE_BUTTON: "manage-targets-done-button",
        },
        TARGETS_VERT_MENU: "targets-vert-menu",
        MANAGE_TARGETS_MENU: "manage-targets-menu",
        DISPLAY_ROWS: "display-rows",
        DISPLAY_COLUMNS: "display-columns",
        FIT_TO_SPACE: "fit-to-space",
    },
    UPDATES_BTN: "updates-btn",
    UPDATES_CONTAINER: "updates-container",
    UPDATES_ENTRY: "updates-entry",
    CREATE_ITEMS_PO: {
        MENU_BUTTON: "create-items-po",
        VALIDATE_ITEM_DATA: "validate-item-data",
        EXPORT_ITEM_PO: "export-item-po",
        MODAL: {
            CREATE_ITEMS: "modal-create-items",
            CREATE_PO: "modal-create-po",
            DIALOG_TITLE: "dialog-title",
            CREATE_ITEMS_CBX: "create-items-cbx",
            CREATE_PO_CBX: "create-po-cbx",
            CREATE_ITEMS_RDB: "create-items-rdb",
            CREATE_PO_RDB: "create-po-rdb",
            TEXT_FIELD: "text-field",
            DATE_FIELD: "date-field",
            SELECT_FIRST: "select-first",
            SELECT_SECOND: "select-second",
            SELECT_FIRST_OPTION: "select-first-option",
            SELECT_SECOND_OPTION: "select-second-option",
        },
        VALIDATE_PO_DATA: "validate-po-data",
        EXPORT_ITEMS: "export-items",
        CREATE_EXPORT: "export-create",
        UPDATE_EXPORT: "export-update",
    },

    BOTTOM_LEFT_GENERIC_TOAST: "bottom-left-generic-toast",

    INCLUDE_DOOR_NOTES_CHK: "include-door-notes",

    DEFAULT_ROW: {
        DEFAULT_ROW_TOGGLE: "default-row-toggle",
        DEFAULT_ROW_LABEL: "default-row-label",
    },

    EXPORT_ERROR_BTN: "export-error-btn",
    EXPORT_ERROR_SUMMARY: "export-error-summary",
    EXPORT_ERROR_ITEM_TAB: "export-error-item-tab",
    EXPORT_ERROR_PO_TAB: "export-error-po-tab",
    EXPORT_LOG_BTN: "export-log-btn",
    EXPORT_LOG_SUMMARY: "export-log-summary",
    EXPORT_MENU_BTN: "export-menu-btn",

    SIZE_SETTINGS_MODAL: {
        TOLERANCE_INPUT: "size-settings-modal-tolerance-input",
        ABOVE_PLANNED_CHECKBOX: "size-settings-modal-above-planned",
        BELOW_PLANNED_CHECKBOX: "size-settings-modal-below-planned",
    },
    GROUPING: {
        SHOW_DOORS: "grouping-show-doors",
        ATTRIBUTES: {
            OPEN: "grouping-attributes-open",
            OPEN_SHOW_DOORS_LABEL: "grouping-attributes-open-show-doors-label",
            OPEN_ADD_ATTRIBUTE_ITEM: "grouping-attributes-open-add-attribute-item",
            OPEN_ADD_ATTRIBUTE_DIALOG: "grouping-attributes-open-add-attribute-dialog",
            OPEN_IMPORT_DOOR_GROUPINGS_DIALOG: "grouping-attributes-import-door-groupings-dialog",
            CONTAINER: "grouping-attributes-container",
            NAME: "grouping-attributes-name",
            INPUT_NAME: "grouping-attributes-input-name",
            SAVE: "grouping-attributes-save-attribute",
            OPEN_DELETE_ATTRIBUTE_DIALOG: "grouping-attributes-open-delete-attribute-dialog",
            OPEN_ATTRIBUTE_OPTIONS_ITEM: "grouping-attributes-open-attribute-options-item",
            EDIT_DOOR_GROUPINGS: "grouping-attributes-edit",
            EDIT_DOOR_GROUPINGS_DIALOG: "grouping-attributes-edit-dialog",
            SHOW_DOORS_LABEL_ITEM: "show-doors-label-item",
            SET_DOOR_GROUPINGS_ITEM: "set-door-groupings-item",
        },
        COLUMN_HEADERS: {
            CUSTOM_HEADERS: {
                RENAME: "grouping-attributes-headers-rename",
            },
        },
    },
    RESET_FILTER_SORT_VIEW: "reset-filter-sort-view",
    DIMENSIONS_FILTER: {
        NO_FILTERS: "dimensions-filter__no-filters",
        OPEN: "dimensions-filter__open",
        CLOSE: "dimensions-filter__close",
        CANCEL: "dimensions-filter__cancel",
        APPLY: "dimensions-filter__apply",
        ADD_FILTER: "dimensions-filter__add-filter",

        MULTIPLE_SELECT_ITEMS: "dimensions-filter__deliveries__select-delivery",
        SINGLE_SELECT_ITEM: "dimensions-filter__deliveries__select-delivery",
    },
    UPC: {
        IMPORT_UPC_BTN: "import-upc-btn",
        IMPORT_UPC_SUCCESS_TEXT: "import-upc-success-text",
    },
};
